import React from "react";
import { Link } from "react-router-dom";

/**
 * Iter XX.45 — Shared trust/legal footer.
 * Consistent across desktop + mobile. Every legal surface reachable
 * from every public page.
 */
export default function Footer({ variant = "default" }) {
  return (
    <footer
      className={`border-t border-neutral-900 px-5 py-6 text-xs text-neutral-500 ${variant === "compact" ? "" : "mt-16"}`}
      style={{ paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom, 0px))" }}
      data-testid="global-footer"
    >
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-between gap-3">
        <span data-testid="footer-copyright">© Gully</span>
        <nav className="flex flex-wrap gap-x-4 gap-y-2 items-center">
          <Link to="/trust" className="hover:text-emerald-300" data-testid="footer-trust">Trust Center</Link>
          <Link to="/privacy" className="hover:text-neutral-300" data-testid="footer-privacy">Privacy</Link>
          <Link to="/terms" className="hover:text-neutral-300" data-testid="footer-terms">Terms</Link>
          <Link to="/legal/partner_agreement" className="hover:text-neutral-300" data-testid="footer-agreement">Partner Agreement</Link>
          <Link to="/legal/referral_policy" className="hover:text-neutral-300" data-testid="footer-referral-policy">Referral Policy</Link>
        </nav>
      </div>
    </footer>
  );
}
